import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import { SaveTokenFunc } from "coral-utility";
import { Provider } from "react-redux";
import store from "state/utils/createStore";
import Connect from "view/connect/Connect";
import { mainTheme } from "view/utils/theme";

// Global Style
export const GlobalStyle = createGlobalStyle`
  html {
    margin: 0;
    padding: 0;
    font-family: ${(props) => props.theme.fonts.heading};
    @media (min-width: 320px) {
    font-size: 12px;
    }
    @media (min-width: 600px) {
      font-size: 14px;
    }
    @media (min-width: 768px) {
      font-size: 16px;
    }
  }
  body {
    background-color: ${(props) =>
      props.theme.backgrounds.background} !important;
  }

  #root {
    min-height: 100vh;
    height: 100%;
  }
`;

export const Routes = () => {
  return (
    <ThemeProvider theme={mainTheme}>
      <Router>
        <Switch>
          <Route
            path={`${process.env.REACT_APP_BASE_URL}/save-token`}
            component={SaveTokenFunc}
          />
          <Route>
            <Connect />
          </Route>
        </Switch>
      </Router>
      <GlobalStyle />
    </ThemeProvider>
  );
};

function RootProvider() {
  return (
    <Provider store={store}>
      <Routes />
    </Provider>
  );
}

export default RootProvider;
